import { AlertCircle, RefreshCw } from 'lucide-react'

import { cn } from '@/utils/ui/styles'

import { Button } from '@/components/ui/button'

type AIPanelErrorProps = {
	error?: unknown
	reset?: () => void
	className?: string
}

function getErrorMessage(error: unknown): string | undefined {
	if (!error) return undefined
	if (error instanceof Error) return error.message
	if (typeof error === 'string') return error
	return undefined
}

/**
 * Error fallback rendered inside the AIR® AI rail / sheet when an AI query
 * throws. Sized `h-full` so it fills the rail column at any viewport height —
 * the host page (search, case management) keeps rendering normally next to it.
 */
export function AIPanelError({ error, reset, className }: AIPanelErrorProps) {
	const message = getErrorMessage(error)

	return (
		<div
			data-slot="ai-panel-error"
			className={cn(
				'flex h-full flex-col items-center justify-center p-6 text-center',
				className,
			)}
		>
			<AlertCircle className="text-destructive mb-3 h-8 w-8" />
			<h3 className="text-sm font-medium">Noah is unavailable</h3>
			<p className="text-muted-foreground mt-1 max-w-xs text-xs">
				We couldn't reach the AI assistant. The rest of the page is still
				working.
			</p>
			{message && (
				<p className="text-muted-foreground/80 mt-2 max-w-xs truncate text-[0.6875rem]">
					{message}
				</p>
			)}
			{reset && (
				<Button onClick={reset} variant="outline" size="sm" className="mt-4">
					<RefreshCw className="mr-2 h-3 w-3" />
					Retry
				</Button>
			)}
		</div>
	)
}
